<template>
	<!-- Page Introduction Wrapper -->
	<div class="page-style-a">
		<div class="container">
			<div class="page-intro">
				<h2>Account</h2>
				<ul class="bread-crumb">
					<li class="has-separator">
						<i class="ion ion-md-home"></i>
						<router-link :to="{name : 'Home'}">Home</router-link>
					</li>
					<li class="is-marked">
						<a href="account.html">Seller Register</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<!-- Page Introduction Wrapper /- -->
	<!-- Account-Page -->
	<div>
		<div class="container-fluid">
			<div class="row justify-content-center">
				<div
					class="col-11 col-sm-10 col-md-10 col-lg-8 col-xl-5 text-center p-0 mt-3 mb-2"
				>
					<div class="card px-0 pt-4 pb-0 mt-3 mb-3">
						<h2 id="heading"><b>Post Requirements</b></h2>
						<p>Fill all form field to go to next step</p>
						<form id="msform">
							<!-- progressbar -->
							<ul id="progressbar">
								<li :class="{active: currentStep > 0}" id="requirements">
									<strong>Requirements</strong>
								</li>
								<li :class="{active: currentStep > 1}" id="details">
									<strong>Details</strong>
								</li>
							</ul>
							<div class="progress">
								<div
									class="progress-bar progress-bar-striped progress-bar-animated"
									role="progressbar"
									:style="{width: currentStep * 50 + '%'}"
									aria-valuemin="0"
									aria-valuemax="100"
								></div>
							</div>
							<br />
							<!-- fieldsets -->
							<fieldset :class="{fieldset_active: currentStep == 1}">
								<form action="" @submit.prevent="nextStep">
									<!-- STEP-1 -->
									<div class="form-card">
										<div class="">
											<label class="fieldlabels"
												>Share your automation requirements in detail (without any confidential details): <span class="text-danger font-weight-bold">*</span></label
											>
											<textarea
												name="requirements"
												id="requirements"
												cols="30"
												rows="10"
												v-model="form.requirements"
												placeholder="No of rooms for automation&#13;&#10;No of electric points in each room&#13;&#10;expected automation features like turn on light when door open"
												required
											></textarea>
										</div>
									</div>
									<button class="next action-button" type="submit">Next</button>
								</form>
							</fieldset>
							<!-- STEP-2 -->
							<fieldset :class="{fieldset_active: currentStep == 2}">
								<form action="" @submit.prevent="nextStep">
									<div class="form-card">
										<div class="">
											<label class="fieldlabels"
												>Budget: <span class="text-danger font-weight-bold">*</span></label
											>
											<select
												class="form-select"
												name="budget"
												aria-label="Default select example"
												v-model="form.budget"
											>
												<option :value="budget" v-for="(budget, index) in budget_array" :key="index">
													{{ formatCurrency(budget) }}
												</option>
											</select>
										</div>
										<div class="">
											<label class="fieldlabels"
												>City: <span class="text-danger font-weight-bold">*</span></label
											>
											<input
												type="text"
												name="city"
												placeholder="City"
												autocomplete="off"
												required
												v-model="form.city"
											/>
										</div>
										<div class="">
											<label class="fieldlabels"
												>Address: <span class="text-danger font-weight-bold">*</span></label
											>
											<input
												type="text"
												name="Address"
												placeholder="Address"
												autocomplete="off"
												required
												v-model="form.address"
												readonly
											/>
										</div>
										<div class="">
											<button
												class="next location-button"
												type="button"
												data-toggle="modal"
												data-target="#post-requirements"
											>
												Select Address
											</button>
										</div>
									</div>
									<button class="next action-button" type="submit">
										{{ currentStep == 2 ? "Submit" : "Next" }}
									</button>
									<button
										class="next action-button"
										@click="prevStep"
										v-if="currentStep > 1"
										type="button"
									>
										Previous
									</button>
								</form>
							</fieldset>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- Account-Page /- -->
	<LocationModal modal_id="post-requirements" @change="handleLocationSelect" />
	<Footer />
	<vue-element-loading
		:active="loading"
		spinner="spinner"
		:is-full-screen="true"
		color="#343a40"
		text="Please Wait..."
	/>
</template>

<script>
	import axios from "axios";
	import Footer from "../components/Bottom/Footer.vue";
	import LocationModal from "../components/Modals/LocationModal";
	import {useToast} from "vue-toastification";
	import {mapGetters} from "vuex";
	import {formatCurrency} from "../utils/common_functions";
	export default {
		components: {Footer, LocationModal},
		computed: {
			...mapGetters("auth", ["isLoggedIn"]),
		},
		data() {
			return {
				currentStep: 1,
				loading: false,
				budget_array: [10000, 20000, 40000, 70000, 150000, 250000],
				form: {
					requirements: "",
					budget: "",
					address: "",
					latitude: "",
					longitude: "",
					city: "",
				},
			};
		},
		methods: {
			formatCurrency,
			async nextStep() {
				if (this.currentStep == 2) {
					this.loading = true;
					try {
						const {data} = await this.saveDataToDB();
						this.loading = false;
						useToast().success(data.message, {timeout: 3000});
						this.clearForm();
						this.currentStep = 1;
						this.$router.push({name: "Requirements"});
					} catch (error) {
						this.loading = false;
						useToast().error(error.response.data.message, {timeout: 3000});
					}
					this.$cookies.remove("form");
					return;
				}
				if (!this.isLoggedIn) {
					localStorage.setItem("redirect", "PostRequirements");
					this.$cookies.set("hash", "#step2");
					this.$cookies.set("form", this.form.requirements);
					this.$router.push({name: "Auth"});
				} else {
					this.currentStep++;
				}
			},
			prevStep() {
				this.currentStep--;
			},
			handleLocationSelect(location) {
				console.log(location);
				this.form.address = location.address;
				this.form.latitude = location.lat;
				this.form.longitude = location.lng;
			},
			async saveDataToDB() {
				const url = `${process.env.VUE_APP_API_URL}/api/automation-requirements`;
				const postData = {
					requirement: this.form.requirements,
					budget: this.form.budget,
					address: this.form.address,
					city: this.form.city,
					latitude: this.form.latitude.toString(),
					longitude: this.form.longitude.toString(),
				};
				const headers = {
					Authorization: `Bearer ${localStorage.getItem("token")}`,
				};
				return axios.post(url, postData, {headers});
			},
			clearForm() {
				this.form.requirements = "";
				this.form.budget = "";
				this.form.address = "";
				this.form.latitude = "";
				this.form.longitude = "";
				this.form.city = "";
			},
		},
		mounted() {
			this.form.budget = this.budget_array[0];
			const hash = this.$route.hash;
			const requirements = this.$cookies.get("form");
			if (hash == "#step2" && requirements) {
				this.form.requirements = requirements;
				this.currentStep = 2;
				this.$cookies.remove("form");
			} else {
				this.$router.push({name: "PostRequirements"});
			}
		},
	};
</script>

<style scoped>
	#heading {
		text-transform: uppercase;
		color: #343a40;
		font-weight: normal;
	}

	#msform {
		text-align: center;
		position: relative;
		margin-top: 20px;
	}

	#msform fieldset {
		background: white;
		border: 0 none;
		border-radius: 0.5rem;
		box-sizing: border-box;
		width: 100%;
		margin: 0;
		padding-bottom: 20px;
		position: relative;
	}

	.form-card {
		text-align: left;
	}
	fieldset {
		display: none;
	}
	.fieldset_active {
		display: block !important;
	}

	#msform input,
	#msform textarea,
	#msform select {
		padding: 8px 15px 8px 15px;
		border: 1px solid #ccc;
		border-radius: 0px;
		margin-top: 2px;
		width: 100%;
	}

	#msform input:focus,
	#msform textarea:focus {
		-moz-box-shadow: none !important;
		-webkit-box-shadow: none !important;
		box-shadow: none !important;
		border: 1px solid #343a40;
		outline-width: 0;
	}

	#msform .action-button {
		width: 100px;
		background: #343a40;
		font-weight: bold;
		color: white;
		border: 0 none;
		border-radius: 5px;
		cursor: pointer;
		padding: 10px 5px;
		margin: 10px 0px 10px 5px;
		float: right;
	}

	#msform .location-button {
		width: 30%;
		background: #343a40;
		font-weight: bold;
		color: white;
		border: 0 none;
		border-radius: 5px;
		cursor: pointer;
		padding: 10px 5px;
		margin: 10px 0px 10px 5px;
	}

	#msform .action-button:hover,
	#msform .action-button:focus {
		background-color: #000000;
	}

	#msform .action-button-previous {
		width: 100px;
		background: #616161;
		font-weight: bold;
		color: white;
		border: 0 none;
		border-radius: 5px;
		cursor: pointer;
		padding: 10px 5px;
		margin: 10px 5px 10px 0px;
		float: right;
	}

	#msform .action-button-previous:hover,
	#msform .action-button-previous:focus {
		background-color: #000000;
	}

	.card {
		z-index: 0;
		border: none;
		position: relative;
	}

	.fs-title {
		font-size: 25px;
		color: #343a40;
		margin-bottom: 15px;
		font-weight: normal;
		text-align: left;
	}

	.steps {
		font-size: 25px;
		color: gray;
		margin-bottom: 10px;
		font-weight: normal;
		text-align: right;
	}

	.fieldlabels {
		color: gray;
		text-align: left;
	}

	#progressbar {
		margin-bottom: 30px;
		overflow: hidden;
		color: lightgrey;
		padding-left: 0px;
	}

	#progressbar .active {
		color: #343a40;
	}

	#progressbar li {
		list-style-type: none;
		font-size: 15px;
		width: 50%;
		float: left;
		position: relative;
		font-weight: 400;
	}

	#progressbar #requirements:before {
		font-family: "Font Awesome 5 Free";
		content: "\f022";
		font-weight: 900;
	}

	#progressbar #details:before {
		font-family: "Font Awesome 5 Free";
		content: "\f03a";
		font-weight: 900;
	}

	#progressbar #payment:before {
		font-family: "Font Awesome 5 Free";
		content: "\f01c";
		font-weight: 900;
	}

	#progressbar #warehouse:before {
		font-family: "Font Awesome 5 Free";
		content: "\f015";
		font-weight: 900;
	}

	#progressbar li:before {
		width: 50px;
		height: 50px;
		line-height: 45px;
		display: block;
		font-size: 20px;
		color: #ffffff;
		background: lightgray;
		border-radius: 50%;
		margin: 0 auto 10px auto;
		padding: 2px;
	}

	#progressbar li:after {
		content: "";
		width: 100%;
		height: 2px;
		background: lightgray;
		position: absolute;
		left: 0;
		top: 25px;
		z-index: -1;
	}

	#progressbar li.active:before,
	#progressbar li.active:after {
		background: #343a40;
	}

	.progress {
		height: 20px;
	}

	.progress-bar {
		background-color: #343a40;
	}

	.fit-image {
		width: 100%;
		object-fit: cover;
	}
	.select_address_button {
		width: 10rem;
		background: #343a40;
		font-weight: bold;
		color: white;
		border: 0 none;
		border-radius: 5px;
		cursor: pointer;
		padding: 10px 5px;
		margin: 10px 0px 10px 5px;
	}
	.form-card div {
		margin-bottom: 20px;
	}
	.is-invalid {
		margin-bottom: -10px !important;
	}
	.is-invalid .invalid-feedback {
		display: block;
		font-weight: bold;
	}
	.is-invalid input {
		border: 1px solid red !important;
	}
	.resend_otp {
		cursor: pointer;
	}
</style>
